import React from 'react';
import styled from 'styled-components';
import CloseIcon from '@material-ui/icons/Close';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import DownloadIcon from '../../icons/DownloadIcon';
import data from '../../api/getDokuments';

export default class Dokument extends React.Component {
  state = {
    selectedDocument: null,
  };

  handleSelectDocument = (selectedDocument) => () => {
    this.setState({ selectedDocument });
  }

  render() {
    const { selectedDocument } = this.state;

    return (
      <div>
        <PageContainer>
          <h1>Dokumenty</h1>
          <TableContainer>
            <h4>Smlouvy o obchodním zastoupení s partnery:</h4>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align='left'>Název</TableCell>
                  <TableCell align='right'>Velikost</TableCell>
                  <TableCell align='right'>Formát</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((d) => (
                  <TableRow key={d.id}>
                    <TableCell align='left'>{d.name}</TableCell>
                    <TableCell align='right'>{d.size}</TableCell>
                    <Box>
                      {d.format}
                      <IconButton
                        style={{ marginLeft: 6 }}
                        src={d.source}
                        onClick={this.handleSelectDocument(d)}
                      >
                        <DownloadIcon
                          style={{ width: 24, height: 24 }}
                        />
                      </IconButton>
                    </Box>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </PageContainer>
        {selectedDocument && (
          <NahledBox onClick={this.handleSelectDocument(null)}>
            <DokumentDetail
              onClick={(e) => e.stopPropagation()}
              selectedDocument={selectedDocument.source}
            >
              <CloseIcon onClick={this.handleSelectDocument(null)} />
            </DokumentDetail>
          </NahledBox>
        )}
      </div>
    );
  }
}

const Box = styled(TableCell)`
  text-align: right !important;

  @media(min-width: 450px) {
    padding-right: 12px;
  }
`;
const TableContainer = styled.div`
  width: 1200px;
  margin: 0 auto;

  @media(max-width: 1200px) {
    width: 100%;
  }
`;
const DokumentDetail = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 100%;
  max-width: 380px;
  height: 100%;
  max-height: 80vh;
  background: url(${(props) => props.selectedDocument});
  background-size: contain;
  background-repeat: no-repeat;

  svg {
    position: absolute;
    top: 8px;
    right: 8px;
    cursor: pointer;
  }
`;
const NahledBox = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  background: rgba(0,0,0,.7);
`;

const PageContainer = styled.div`
  padding: 24px 24px 48px 24px;
  width: 100%;
  h3 { padding: 6px 0; }

  @media(max-width: 500px) {
    padding: 24px 3%;
    h4 { margin: 20px 0 6px 0; }
    td, tr, th { padding: 0 4px !important; }
  }
`;
